import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
    CallToActionService,
    CallToActionConfig,
    CallToActionLocation
} from '../../core-services/CallToAction.service';

@Component({
    selector: 'call-to-action',
    host: {
        class: 'ctaContainer'
    },
    template: `
        <div class="layoutCenteredColumn">
            @for (config of configs; track config) {
                <div
                    class="layoutVertical"
                    style="text-align: left; padding: 20px;"
                >
                    <div class="largeBoldText color-neutral-900">
                        {{ config.title }}
                    </div>
                    <div
                        class="smallText color-neutral-900"
                        style="margin: 10px 0 10px;"
                    >
                        {{ config.detailText }}
                    </div>
                    <button
                        class="button button-sm button-secondary bg-color-white"
                        style="max-width: 67%; background-color: white;"
                        (click)="clickEvent(config)"
                    >
                        {{ config.buttonTitle }}
                    </button>
                </div>
            }
        </div>
    `,
    standalone: false
})
export class CallToActionComponent implements OnInit {
    @Input()
    location: CallToActionLocation;
    @Output()
    actionFired = new EventEmitter();

    configs: CallToActionConfig[];

    constructor(
        private ctaService: CallToActionService,
        public router: Router
    ) {}

    ngOnInit() {
        this.configs = this.ctaService.getConfigForLocation(this.location);
    }

    clickEvent(config: CallToActionConfig) {
        // Not sure what to emit, leaving it to future devs to make a useful choice
        this.actionFired.emit(config);
        if (config.routerLink) {
            this.router.navigate([config.routerLink]);
        }
    }
}
